import React, { useEffect, useState, useRef, Component } from 'react';
import { MessageSquare } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
// Map routes to their accent colors
function getAccentColor(pathname: string): string {
  if (pathname.includes('subcontractors') || pathname.includes('contractors')) {
    return '#fbbf24'; // amber-400 — matches info bar yellow
  }
  // Default brand accent for all other pages
  return '#04A05C';
}
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const scrollTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const lastScrollY = useRef(0);
  const location = useLocation();
  const accentColor = getAccentColor(location.pathname);
  const isContractors = location.pathname.includes('subcontractors') || location.pathname.includes('contractors');
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const isScrollingDown = currentY > lastScrollY.current && currentY > 100;
      lastScrollY.current = currentY;
      if (isScrollingDown) {
        setVisible(true);
      }
      // Clear existing timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      // Hide after 1 second of no scrolling
      scrollTimeoutRef.current = setTimeout(() => {
        setVisible(false);
      }, 1000);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);
  return <AnimatePresence data-id="element-1836" data-mp="1vb9ve2lj0xtg">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 30
    }} className="fixed bottom-4 left-4 z-40 md:hidden" data-id="element-1837" data-mp="1vc1e4cu0z12b">
          <a href={`sms:2066193742?body=${encodeURIComponent("Hi, I'm on your website and I have a question")}`} className={`flex items-center justify-center shadow-lg opacity-80 ${isContractors ? 'text-stone-900' : 'text-white'}`} style={{
        width: 55,
        height: 36,
        borderRadius: 18,
        backgroundColor: accentColor
      }} aria-label="Chat Now" data-id="element-1838" data-mp="1mz7wv9ge080y">
            <MessageSquare className="w-5 h-5" data-id="element-1839" data-mp="25sbsh0d60uy7" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}